/**
 * Hook for restoring detached window position/size on load
 * Reads from localStorage and applies saved position/size
 */

import { useEffect } from 'react';

export function useRestoreDetachedWindowPosition() {
  useEffect(() => {
    // Only run in detached windows
    const isDetached = new URLSearchParams(window.location.search).get('detached') === 'true';
    const traderId = new URLSearchParams(window.location.search).get('traderId');

    if (!isDetached || !traderId) return;

    // Wait a bit for window to fully load, then restore position
    const timeout = setTimeout(() => {
      try {
        const key = `detached-window-${traderId}`;
        const stored = localStorage.getItem(key);

        if (stored) {
          const { x, y, width, height, timestamp } = JSON.parse(stored);

          // Verify data is recent (within last 24 hours)
          const isRecent = Date.now() - timestamp < 24 * 60 * 60 * 1000;

          if (isRecent && typeof x === 'number' && typeof y === 'number' &&
              typeof width === 'number' && typeof height === 'number') {
            try {
              // Restore window position and size
              window.moveTo(x, y);
              window.resizeTo(width, height);
              console.log(`[DetachedWindow] Restored position: ${x}, ${y}, ${width}x${height}`);
            } catch (err) {
              console.warn('[DetachedWindow] Could not restore window position (may be restricted):', err);
            }
          }
        }
      } catch (err) {
        console.error('[DetachedWindow] Failed to restore window state:', err);
      }
    }, 500); // Wait 500ms for window to fully load

    return () => clearTimeout(timeout);
  }, []);
}
